import { Route } from '@/app/routes/(app)/points-management/points-configuration/customer/$programId';
import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerReferralStageQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { CustomerReferralStageList } from '@/services/pointConfiguration/pointConfiguration.types';
import { useSearch } from '@tanstack/react-router';

export const useReferralStageList = () => {
  const search = useSearch({ from: '/(app)/points-management/points-configuration/customer/$programId/' });
  const { programId } = Route.useParams();
  const dates = parseDateRangeSearch(search.createdDate, { start: 0, end: 0 });
  const params = {
    row: search.page,
    fetch: search.fetch,
    search: search.q ?? '',
    fromDate: dates?.start ?? 0,
    toDate: dates?.end ?? 0,
    programId,
  };
  const { data, isLoading } = useQuery<PaginatedApiResponse<CustomerReferralStageList[]>>({
    ...customerReferralStageQueries.list(params),
    select: (res) => ({ ...res, data: sortBy(res.data, search.sort) }),
  });
  return { referralStage: data?.data ?? [], loading: isLoading, pagination: data?.meta?.pagination ?? defaultMeta };
};
